export default {
    ENTER: 13,
    ESCAPE: 27
}